import { all, call, put, takeLatest } from 'redux-saga/effects';

import { DASHBOARD_SLICE_PATHS } from './constants';
import {
  fetchDashboardRequest,
  fetchSliceError,
  fetchSliceSuccess,
} from './index';

/**
 * One slice of one dashboard. Errors are caught here rather than by the caller
 * so a single failing endpoint cannot abort its siblings inside `all` — the
 * dashboard renders what succeeded and the failed card says it failed.
 */
export function* fetchSlice(requestFn, { id, slice, path, subsidiaryId }) {
  try {
    const response = yield call(requestFn, { path, subsidiaryId });

    yield put(fetchSliceSuccess({ id, slice, data: response.data }));
  } catch (error) {
    // Deliberately not reported here. The shared axios `errorInterceptor`
    // already calls `captureException` for every non-401/403 failure, so a
    // second call made 2 events per slice — 16 per page view on the cost tab,
    // arriving in a burst because the slices fan out in parallel.
    yield put(fetchSliceError({ id, slice, error: error.message }));
  }
}

export const requestDashboard = requestFn =>
  function* requestHandler({ payload: { id, subsidiaryId } }) {
    const slicePaths = DASHBOARD_SLICE_PATHS[id];

    // No BigQuery behind this dashboard yet. `DASHBOARD_SLICE_PATHS` is the
    // registry of what insights-views can serve, so an unkeyed id has nothing
    // to request rather than something to request differently.
    if (!slicePaths) {
      return;
    }

    yield all(
      Object.entries(slicePaths).map(([slice, path]) =>
        call(fetchSlice, requestFn, { id, slice, path, subsidiaryId }),
      ),
    );
  };

export function* insightsViewsRequestWatcher(requestFn) {
  yield takeLatest(fetchDashboardRequest.type, requestDashboard(requestFn));
}
